import React from 'react';
import Icon from "../";
export default function IconX(props) {
  return React.createElement(Icon, Object.assign({}, props, {
    dangerouslySetInnerHTML: {
      __html: "<path d=\"M4.93 4.93l14.14 14.14m-14.14 0L19.07 4.93\" fill=\"none\" stroke=\"#181818\"/>"
    }
  }));
}